import { toast } from "react-toastify";
import {
  CREATE_ARTICLE_LOADING,
  CREATE_ARTICLE_SUCCESS,
  CREATE_ARTICLE_FAIL,
  GET_ALL_ARTICLES,
  GET_ONE_ARTICLE,
  GET_ALL_ARTICLES_FAIL,
  GET_ALL_ARTICLES_LOADING,
  GET_ONE_ARTICLE_FAIL,
  GET_ONE_ARTICLE_LOADING,
} from "../actionTypes/actionTypes";
import axiosInstance from "../../axios/axios.instance";

/* istanbul ignore next */
export const createArticle = (article) => async (dispatch: any) => {
  try {
    dispatch({ type: CREATE_ARTICLE_LOADING });
    const res = await axiosInstance.post(`/articles`, article);
    dispatch({
      type: CREATE_ARTICLE_SUCCESS,
      payload: res.data,
      error: null,
    });
    toast.success(res.data.message);
  } catch (error: any) {
    toast.error(error.response.data.message);
    dispatch({ type: CREATE_ARTICLE_FAIL, payload: error.response.data });
  }
};

export const getAllArticles = () => async (dispatch: any) => {
  try {
    dispatch({ type: GET_ALL_ARTICLES_LOADING });
    const res: any = await axiosInstance.get(`articles`);

    dispatch({
      type: GET_ALL_ARTICLES,
      payload: res.data,
      error: null,
    });
    // toast.success(res.data.message);
  } catch (error: any) {
    toast.error(error);
    dispatch({ type: GET_ALL_ARTICLES_FAIL, payload: error });
  }
};

export const getOneArticle = (articleId: string) => async (dispatch: any) => {
  try {
    dispatch({ type: GET_ONE_ARTICLE_LOADING });
    const res = await axiosInstance.get(`articles/${articleId}`);

    dispatch({
      type: GET_ONE_ARTICLE,
      payload: res.data,
      error: null,
    });
    // toast.success(res.data.message);
  } catch (error: any) {
    toast.error(error.response.data.message);
    dispatch({ type: GET_ONE_ARTICLE_FAIL, payload: error.response.data });
  }
};
